module.exports = __webpack_public_path__ + "static/page_banner_background-0f36de1ce0741bc515ba91352b86ee4f.png";